import axios from 'axios'

export default {
  namespaced: true,
  state: {
    events: [],
    event: null,
    count: 1
  },
  mutations: {
  },
  getters: {
  },
  actions: {
    async get ({ state }, { params }) {
      let data = await axios.get('/events', { params })
      state.events = data.data
    },
    async create ({ commit, state }, data) {
      await axios.post('/events', data)
    },
    async update ({ state, commit }, { id, data }) {
      console.log(data, 'patch me')
      await axios.patch(`/events/${id}`, data)
    },
    delete () {},
    async getCount ({ state }, { params }) {
      let data = await axios.get('/events/count', { params })
      state.count = data.data[0].total
    },
    setEvent ({ state }, id) {
      state.event = state.events.find((e) => {
        return e.id === id
      })
    }
  }
}
